import {SectionItem} from 'common/components/items-menu/types';
import {PRIMATIVE_MATH_TYPES, NUMERIC_MATH_TYPES, MATH_TYPE, XAU_MATH_TYPES} from 'common/report/constants';
import {ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {
  QueryEventEntry,
  FilterOperator,
  SelectorType,
  SelectorTypeDefinitions,
} from 'common/widgets/query-event-selector/types';
import {EventItem} from 'common/widgets/query-block/events-menu/types';

export enum Action {
  Add = `add`,
  AddFilter = `addFilter`,
  ApplyProperty = `applyProperty`,
  Clone = `clone`,
  Drag = `drag`,
  Edit = `edit`,
  EditFilter = `editFilter`,
  Remove = `remove`,
  RemoveFilter = `removeFilter`,
  Select = `select`,
  SelectDateRange = `selectDateRange`,
}

export enum RowLabelType {
  None = `none`,
  Alpha = `alpha`,
  Numeric = `numeric`,
}

export enum EntryType {
  Event = `event`,
  ExclusionEvent = `exclusion-event`,
}

export const ExclusionStepResourceType = `exclusion-event`;

export interface RowTypeComplexOption extends SectionItem {
  value: SelectorType;
  readOnlyEvent?: EventItem;
}

export type RowTypeOption = SelectorType | RowTypeComplexOption;

export const SelectorTypesLabels: {[key in SelectorType]?: string} = {
  [ResourceType.Event]: `event`,
  [ResourceType.Cohort]: `cohort`,
  [SelectorTypeDefinitions.EventOrUserProperty]: `property`,
  [SelectorTypeDefinitions.UserProperty]: `user property`,
  [SelectorTypeDefinitions.Behavior]: `behavior`,
  [SelectorTypeDefinitions.EventLaunch]: `event`,
};

const EMPTY_EVENT: EventItem = Object.freeze({
  id: null,
  custom: false,
  label: ``,
  value: null,
});

export const EMPTY_EVENT_ENTRY = Object.freeze({
  aggregationOperator: PRIMATIVE_MATH_TYPES.TOTAL,
  event: EMPTY_EVENT,
  filters: [],
  filtersOperator: FilterOperator.And,
  property: null,
  type: ResourceType.Event,
}) as QueryEventEntry;

export const EMPTY_EXCLUSION_EVENT_ENTRY: QueryEventEntry = Object.freeze({
  ...EMPTY_EVENT_ENTRY,
  excludeAll: true,
  excludeRange: {},
});

const EVENT_MATH_TYPES: MATH_TYPE[] = [...Object.values(PRIMATIVE_MATH_TYPES), ...Object.values(XAU_MATH_TYPES)];

const PROPERTY_MATH_TYPES: MATH_TYPE[] = [
  ...Object.values(PRIMATIVE_MATH_TYPES).filter(
    (value) => value !== PRIMATIVE_MATH_TYPES.UNIQUE && value !== PRIMATIVE_MATH_TYPES.SESSIONS,
  ),
  ...Object.values(NUMERIC_MATH_TYPES),
];

/** Defines the type of math operators for all selector types */
export const SelectorTypeMathFunctions: {[key in SelectorType]?: MATH_TYPE[]} = {
  [ResourceType.Cohort]: [PRIMATIVE_MATH_TYPES.UNIQUE],
  [ResourceType.User]: [PRIMATIVE_MATH_TYPES.TOTAL],
  [ResourceType.Event]: EVENT_MATH_TYPES,
  [SelectorTypeDefinitions.EventOrUserProperty]: PROPERTY_MATH_TYPES,
  [SelectorTypeDefinitions.UserProperty]: PROPERTY_MATH_TYPES,
  [SelectorTypeDefinitions.Behavior]: [PRIMATIVE_MATH_TYPES.TOTAL],
  [SelectorTypeDefinitions.EventLaunch]: EVENT_MATH_TYPES,
};
